import { useEffect } from "react";

import { toasts } from "../../toasts";
import { useCountdown } from "../../use-countdown";
import { PureClock } from "./PureClock";

interface Props {
  /**
   * End date as ISO8601 date string to count down towards.
   */
  endDate: string;
  /**
   * Message suffix.
   *
   * e.g. to display "10 minute of writing time remanining", "10 minutes" is the
   * countdown message, and the "of writing time remaining" is the suffix.
   */
  suffix: string;
  /**
   * Optionally trigger a countdown toast when a certain number of seconds is
   * left until the endDate.
   *
   * The toast will count down seconds from the given value until 0.
   */
  triggerCountdownSeconds?: number;
  /** Render an inline version of the clock that is not floating on the page. */
  inline?: boolean;
}

/**
 * Render a `PureClock` with a running countdown towards an end date.
 */
export function ClockWithCountdown(props: Props) {
  const { endDate, suffix, triggerCountdownSeconds } = props;
  const { message, milliseconds, passed } = useCountdown(endDate);

  const startCountdown =
    triggerCountdownSeconds &&
    !passed &&
    milliseconds <= triggerCountdownSeconds * 1000
      ? triggerCountdownSeconds
      : null;

  useEffect(() => {
    if (startCountdown) {
      toasts.submitCountdown(startCountdown);
    }
  }, [startCountdown]);

  if (passed) {
    return null;
  }

  return <PureClock message={message} suffix={suffix} inline={props.inline} />;
}
